@if (constructorForm) {
  <div class="modal-header policy-form d-flex flex-column justify-content-center">
    <div class="d-flex flex-row justify-content-between">
      <div class="d-flex flex-row align-items-center modal-back" type="button" (click)="sendClose('Cross click')">
        <button></button>
        <h3>{{ 'back' | translate }}</h3>
      </div>
      <div class="hwithbuttons d-flex flex-row justify-content-center align-items-center">
        @if (!editing) {
          <app-form-add-policy-and-simulation class="submit"  [policy]="policy"></app-form-add-policy-and-simulation>
        }
        
        @if (create) {
          <h2 class="modal-title" id="modal-basic-title">Create {{ policy?.name }}</h2>
        }
        @if (!create && editing) {
          <h2 class="modal-title edit-name d-flex flex-row justify-content-around align-items-center" id="modal-basic-title">
            {{ 'editing' | translate }}
            <input class="form-control" [formControl]="getFormControl('name')">
          </h2>
        }
        @if (!editing && !create) {
          <h2 class="modal-title" id="modal-basic-title">{{ policy?.name }}</h2>
        }
        @if (editing) {
          <button (click)="saveChange(); sendClose('Cross click')" [disabled]="!allFormMatch()" class="btn btn-outline-success">
            {{ 'security-policies-details-button-save' | translate }}
          </button>
        }
        @if (!editing) {
          <div class="d-flex flex-row">
            <button class="btn btn-outline-success submit" (click)="sendAction('submit')">
              {{ 'security-policies-details-button-submit' | translate }}
            </button>
            <button class="btn btn-outline-primary d-flex flex-row align-items-center edit" (click)="editing=true">
              <img src="assets/icons/Policies/edit.svg">
              {{ 'security-policies-details-button-edit' | translate }}
            </button>
            <button class="btn btn-outline-danger d-flex flex-row align-items-center cross delete" (click)="sendAction('delete')">
              <img src="assets/icons/Policies/cross.svg">
              {{ 'security-policies-details-button-delete' | translate }}
            </button>
          </div>
        }
      </div>
      <button type="button" class="modal-close" aria-label="Close" (click)="sendClose('Cross click')"></button>
    </div>
    @if (getFormControl('name').invalid && getFormControl('name').dirty) {
      <div class="alert alert-head alert-danger">
        @if (getFormControl('name').errors?.['required']) {
          {{ 'setting-form-error-required' | translate }}
        }
        @if (getFormControl('name') && getFormControl('name').errors?.['exist']) {
          {{ 'setting-form-error-already-exist' | translate }}
        }
        @if (getFormControl('name').errors?.['whitespace']) {
          {{ 'setting-form-error-invalid-value' | translate }}
        }
      </div>
    }
    <div class="d-flex flex-row justify-content-center align-items-center fbuttons">
      <h2>{{ 'security-policies-modal-go-to' | translate }}</h2>
      <div class="d-flex flex-wrap justify-content-center">
        @for (fam of getAllFamilyofDetectors(); track fam) {
          <button class="btn btn-outline-primary" (click)="accordeon.toggle(fam.toLowerCase()); scroolTo(fam.toLowerCase())">
            {{ fam }}
          </button>
        }
      </div>
    </div>
  </div>
  <div id="modal-body" class="modal-edit-policy modal-body d-flex justify-content-center">
    <div ngbAccordion #accordeon="ngbAccordion">
      @for (fam of getAllFamilyofDetectors(); track $index) {
        <div ngbAccordionItem="{{ fam.toLowerCase() }}">
          <div ngbAccordionHeader>
            <button ngbAccordionButton class="accordion-button">
              <div class="d-flex title justify-content-between align-items-center">
                <h2>{{ fam }}</h2>
                @if (editing) {
                  <button (click)="$event.preventDefault(); $event.stopPropagation(); resetFamily(fam)"
                    [disabled]="!haveChange(fam)" class="btn btn-outline-primary d-flex align-items-center resetFamily">
                    <img src="assets/icons/reset.svg" alt="reset">
                    {{ 'reset-parameters' | translate }}
                  </button>
                }
                @if (!editing) {
                  <div class="tags d-flex flex-row justify-content-around">
                    <div class="tag d-flex flex-row justify-content-center">
                      <h3 class="name total">{{ 'security-policies-details-total' | translate }}</h3>
                      <h3 class="value">{{ getTotalLength(fam) }}</h3>
                    </div>
                    <div class="tag d-flex flex-row justify-content-center">
                      <h3 class="name fatal">{{ 'security-policies-details-fatal' | translate }}</h3>
                      <h3 class="value">{{ getFatalLength(fam) }}</h3>
                    </div>
                  </div>
                }
              </div>
            </button>
          </div>
          <div ngbAccordionCollapse>
            <table ngbAccordionBody class="table">
              <thead>
                <tr>
                  <th class="short" scope="col">{{ 'security-policies-details-tab-detector' | translate }}</th>
                  <th class="short text-center" scope="col">{{ 'security-policies-details-tab-activation' | translate }}</th>
                  <th class="long text-center" scope="col">{{ 'security-policies-details-tab-status' | translate }}</th>
                  <th class="long text-center" scope="col">
                    {{ 'security-policies-details-on-demand' | translate }}/{{ 'security-policies-details-periodic' | translate }}
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (detector of getAllDetectorOfFam(fam); track $index) {
                  @if (detector && detector.name) {
                    <tr>
                      <td>
                        <div class="d-flex justify-content-begin">{{ detector.name }}</div>
                      </td>
                      @if (editing) {
                        <td>
                          <div class="d-flex justify-content-center">
                            <mat-slide-toggle [checked]="getVDetector(fam, detector.name)['active']"
                              (change)="toogle($event, fam, detector.name)">
                            </mat-slide-toggle>
                          </div>
                        </td>
                        <td>
                          <div class="d-flex align-items-center justify-content-center">
                            <div ngbDropdown class="d-inline-block">
                              <button type="button" [disabled]="!getVDetector(fam, detector.name)['active']"
                                class="d-flex align-items-center btn btn-outline-primary" id="status-detector"
                                ngbDropdownToggle>
                                @if (getVDetector(fam, detector.name)['status'] != '') {
                                  {{ fStatusString(getVDetector(fam, detector.name)['status']).toUpperCase() }}
                                } @else {
                                  DESACTIVE
                                }
                              </button>
                              <div ngbDropdownMenu aria-labelledby="status-detector">
                                <button ngbDropdownItem
                                  (click)="setStatut('fatal', fam.toLowerCase(), detector.name.toLowerCase())">STATUS_FATAL</button>
                                <button ngbDropdownItem
                                  (click)="setStatut('warning', fam.toLowerCase(), detector.name.toLowerCase())">STATUS_WARNING</button>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="d-flex flex-column align-items-center justify-content-center">
                            <div class="d-flex flex-row checkbox">
                              <p class="ondemand">
                                <mat-checkbox [formControl]="getControl('in_demand', getOptions(fam, detector.name))">
                                  {{ 'security-policies-details-on-demand' | translate }}
                                </mat-checkbox>
                              </p>
                              <p class="periodic">
                                <mat-checkbox [formControl]="getControl('periodic', getOptions(fam, detector.name))">
                                  {{ 'security-policies-details-periodic' | translate }}
                                </mat-checkbox>
                              </p>
                            </div>
                            @if (getVDetector(fam, detector.name)['active'] &&
                              formDetectorActive.get(fam.toLowerCase())?.get(detector.name.toLowerCase())?.get('typeactiveinapp')?.errors?.['allfalse']) {
                              <div class="cross-validation-error-message alert alert-danger">
                                {{ 'security-policies-edit-checkbox-error' | translate }}
                              </div>
                            }
                          </div>
                        </td>
                      } @else {
                        <td>
                          <div class="d-flex justify-content-center">
                            <img src="assets/icons/Policies/checkmark.svg" class="{{ statutactive(detector) }}">
                          </div>
                        </td>
                        <td>
                          <div class="d-flex justify-content-center">{{ formatStatus(detector) }}</div>
                        </td>
                        <td>
                          <div class="d-flex justify-content-center">{{ formatPId(detector) }}</div>
                        </td>
                      }
                    </tr>
                  }
                }
              </tbody>
            </table>
          </div>
        </div>
      }
    </div>
    <app-toast-component></app-toast-component>
  </div>
}
@else {
  <app-loading-error [boolean]="true"></app-loading-error>
}
<ng-template #simulate let-c="close" let-d="dismiss">
  <app-form-add-policy-and-simulation [policy]="policy" [addpolicy]="false"
    (action)="modaldismiss($event)"></app-form-add-policy-and-simulation>
</ng-template>